<template lang="pug">
  div.col-12(v-if="currentUser.rights.simCallsProjects == true")
    .content-wrapper
      h2.m-0 Проекты обзвона
      button.btn.btn-info.col-2(v-on:click='createProject' v-if="currentUser.rights.simCallsProjectsEdit") Добавить проект
      table.table.table-hover
        thead
          tr
            th(v-for="h in columnsHeader" v-bind:key="h.key" v-on:click="sortBy(h.key)" v-bind:class="{ active: sortKey == h.key }") {{ h.title }}
              span(v-bind:class="['arrow', sortOrders[h.key] > 0 ? 'asc' : 'dsc']")
        tbody
          tr(v-for="row in projectsList" v-bind:key="row.id")
            td(v-for="td in columnsHeader" v-bind:key="td.id") {{ row[td.key] }}
              span.td-actions(v-if="td.key === 'actions' && currentUser.rights.simCallsProjectsEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startProject(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopProject(row.id)')
                i.far.fa-pen.mr-2(v-on:click='showModal(row.id)')
                i.far.fa-trash.mr-2(v-on:click='deleteProject(row.id)')
              span.td-actions(v-if="td.key === 'actions' && !currentUser.rights.simCallsProjectsEdit")
                i.far.fa-play.mr-2(v-if="!row.is_active" v-on:click='startProject(row.id)')
                i.far.fa-pause.mr-2(v-if="row.is_active" v-on:click='stopProject(row.id)')
    modal(v-show="isModalVisible" v-on:close="closeModal")
      template(v-slot:header="")
        div.d-block.col-12
          h2 {{ modalData.project.name }}
          .form-group
            button.btn.btn-info.col-2(v-on:click="saveProject") Сохранить
            span &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            button.btn.btn-secondary.col-2(v-on:click='closeModal') Отмена
      template(v-slot:body="")
        div
          fieldset
            .form-group.col-12
              label Название
              input.form-control(v-model='modalData.project.name' type='text' placeholder='Введите название проекта' required='')
            .form-group.col-12
              label Город
              input.form-control(v-model='modalData.project.city' type='text' placeholder='Введите название города' required='')
            .form-group.col-12
              label Часовой пояс
              input.form-control(v-model='modalData.project.timezone' type='number' placeholder='Введите название города' required='')
            .form-group.col-12
              label Начало обзвона
              input.form-control(v-model='modalData.project.start' type='text' placeholder='Введите час начала обзвона' required='')
            .form-group.col-12
              label Конец Обзвона
              input.form-control(v-model='modalData.project.stop' type='text' placeholder='Введите час до которого звонить' required='')
            .form-group.col-12
              label Аудио
              input.form-control(v-model='modalData.project.audio' type='text' placeholder='Введите аудиозапись для воспроизведения' required='')
            .form-group.col-12
              label Перевод
              input.form-control(v-model='modalData.project.transfer' type='text' placeholder='Введите что-то для перевода' required='')
      template(v-slot:footer="")
        .form-group.d-flex.justify-content-end.col-12
          button.btn.btn-secondary.col-2(v-on:click="closeModal") Закрыть
  .alert.alert-warning.alert-dismissible.fade.show(v-else role="alert")
    <strong>Внимание!</strong> У Вас нет прав доступа в этот раздел.
    button.close(type="button" data-dismiss="alert" aria-label="Close")
      span(aria-hidden="true") &times;
</template>

<script>
export default {
  data () {
    var columnsHeader = [
      {title: 'ID базы', key: 'id'},
      {title: 'Название', key: 'name'},
      {title: 'Активен', key: 'state'},
      {title: 'Город', key: 'city'},
      {title: 'Часовой пояс', key: 'timezone'},
      {title: 'Начало', key: 'start'},
      {title: 'Конец', key: 'stop'},
      {title: 'Аудио', key: 'audio'},
      {title: 'Перевод', key: 'transfer'},
      {title: 'Действия', key: 'actions'}
    ]
    // const FORMAT = 'YYYY-MM-DD'
    var sortOrders = {}
    columnsHeader.forEach(function (key) {
      sortOrders[key.key] = 1
    })
    return {
      sortKey: '',
      isModalVisible: false,
      modalData: {},
      emptyModalData: null,
      sortOrders: sortOrders,
      columnsHeader: columnsHeader,
      openProject: 0,
      projects: []
    }
  },
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    projectsList: function () {
      let list = []
      this.projects.forEach((item) => {
        item.actions = ''
        item.state = item.is_active ? 'Активен' : 'Остановлен'
        list.push(item)
      })
      if (this.sortKey) {
        let order = this.sortOrders[this.sortKey] || 1
        list = list.sort((a, b) => {
          let x = a[this.sortKey]
          let y = b[this.sortKey]
          if (typeof x == 'string') {
            x = x.toLowerCase()
            y = y.toLowerCase()
          }
          return (x === y ? 0 : x > y ? 1 : -1) * order
        })
      }
      return list
    },
    client_id: function () {
      return this.$store.getters.client_id
    },
    currentUser: function () {
      return this.$store.getters.user
    }
  },
  methods: {
    sortBy (key) {
      this.sortKey = key
      this.sortOrders[key] *= -1
    },
    showModal (projectId = 0) {
      this.openProject = projectId
      if (projectId < 1) {
        this.resetModalData()
        this.isModalVisible = true
        return true
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/get.php&id=' + projectId)
        .then(response => {
          this.isModalVisible = true
          this.modalData.project = response.data.project
        })
    },
    closeModal () {
      this.openProject = 0
      this.isModalVisible = false
    },
    resetModalData () {
      this.emptyModalData = {}
      this.modalData.project = {id: 0, name: "Новый проект", is_active: 1, city: "Moscow", start: 9, stop: 18, timezone: 3, audio: "", transfer: ""}
      this.emptyModalData.project = {id: 0, name: "Новый проект", is_active: 1, city: "Moscow", start: 9, stop: 18, timezone: 3, audio: "", transfer: ""}
    },
    createProject () {
      this.showModal()
    },
    saveProject () {
      let p = {}
      p.project = JSON.stringify(this.modalData.project)
      if (this.modalData.project.id > 0) {
        p.url = '/api/project/update.php'
      } else {
        p.url = '/api/project/add.php'
      }
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/simCalls.php', p)
        .then(() => { this.getProjectList() })
      this.closeModal()
    },
    startProject (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/update.php&is_active=1&id=' + id)
        .then(response => {
          this.getProjectList()
        })
    },
    stopProject (id) {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/update.php&is_active=0&id=' + id)
        .then(response => {
          this.getProjectList()
        })
    },
    deleteProject (id) {
      if (!confirm('Подтвердите удаление проекта')) {
        return false
      }
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/delete.php&id=' + id)
        .then(response => {
          this.getProjectList()
        })
    },
    getProjectList () {
      this.axios.get(this.systemSettings.api_host + '/simCalls.php?url=/api/project/get.php')
        .then(response => {
          this.projects = response.data.list
        })
    }
  },
  mounted () {
    this.resetModalData()
    this.getProjectList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/simCalls/projects.vue